// extracted by mini-css-extract-plugin
export default {"root":"Actions_root__CpoH1"};